<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script src="https://unpkg.com/vue/dist/vue.global.prod.js"></script>
<script src="https://unpkg.com/axios/dist/axios.min.js"></script>
<script>
import axios from 'axios'
export default {
  name: 'App',
}
history.replaceState({}, null, location.pathname)
</script>
<style scoped>
@import '../src/style/common.css';

#app {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Noto Sans KR', sans-serif;
}
</style>
